const colorsArray = [
    {
      label: "Black",
      value: "#000000",
    },
    {
      label: "Grey",
      value: "#808080",
    },
    {
      label: "Blue",
      value: "#0850f7",
    },
    {
      label: "Orange",
      value: "#F79722",
    },
    {
      label: "Crimson",
      value: "#DC143C",
    },
    {
      label: "Pink",
      value: "#FFC0CB",
    },
    {
      label: "Yellow",
      value: "#FFFF00",
    },
    {
      label: "Violet",
      value: "#EE82EE",
    },  
    {
      label: "DarkOrchid",
      value: "#9932CC",
    },
    {
      label: "Lime",
      value: "#00FF00",
    },
    {
      label: "SeaGreen",
      value: "#2E8B57",
    },
    {
      label: "Turquoise",
      value: "#40E0D0",
    },
    {
      label: "Bisque",
      value: "#FFE4C4",
    },
    
  ];

  const colorsArrayDisPlayOrder = [
    {
        label: "Blue",
        value: "#0850f7",
    },
    {
        label: "DarkOrchid",
        value: "#9932CC",
    },
    {
        label: "Turquoise",
        value: "#40E0D0",
    },
    {
        label: "Crimson",
        value: "#DC143C",
    },
    {
      label: "Black",
      value: "#000000",
    },
    {
      label: "Grey",
      value: "#808080",
    },
    {
      label: "Orange",
      value: "#F79722",
    },
    {
      label: "Pink",
      value: "#FFC0CB",
    },
    {
      label: "Yellow",
      value: "#FFFF00",
    },
    {
      label: "Violet",
      value: "#EE82EE",
    },  
    {
      label: "Lime",
      value: "#00FF00",
    },
    {
      label: "SeaGreen",
      value: "#2E8B57",
    },
    {
      label: "Bisque",
      value: "#FFE4C4",
    },
  ];

const gridUnitSizes = [
    {
      label: "Very small",
      gridValues: "20x20",
      value: 15
    },
    {
      label: "Small",
      gridValues: "10x10",
      value: 24
    },
    { 
      label: "Medium",
      gridValues: "10x10",
      value: 38
    },
    {
      label: "Large",
      gridValues: "6x6",
      value: 72
    },
    {
      label: "Very large",
      gridValues: "2x2",
      value: 100
    },
  ];

  const AngleDisplayOptions = [
    {
      label: "Angle displayed (by an arc) is the smallest angle, and always positive, question author can designate the reference (that is the axis from which the angle is referred. The reference can be at any angle compared to the +x axis). Question author can designate the reference",
      value: 1,
    },
    {
      label: "Angle displayed (by an arc) is chosen to start from the reference and go either clockwise or counterclockwise, and always is positive. Question author can designate the reference, and CC/CCW option",
      value: 2,
    },
    {
      label: "Angle displayed (by an arc) starts from the +x axis as the reference and will be the smallest angle, but will be indicated as positive number if the angle is CCW from the reference and negative if CW from the reference",
      value: 3,
    }
  ];

  const evaluateOptions = [
    {
      label: "=",
      value: 0,
    },
    {
      label: ">",
      value: 1,
    },
    {
      label: "<",
      value: 2,
    },
    {
      label: ">=",
      value: 3,
    },
    {
      label: "<=",
      value: 4,
    }
  ];
  const QueryOptions = [
    {
      label: "AND",
      value: 0,
    },
    {
      label: "OR",
      value: 1,
    }
  ];

  const getColorsArrayDisPlayOrder = (index) =>{
	return colorsArrayDisPlayOrder[index%colorsArrayDisPlayOrder.length].value
  }

  export { colorsArray, colorsArrayDisPlayOrder, gridUnitSizes, AngleDisplayOptions, getColorsArrayDisPlayOrder,evaluateOptions,QueryOptions };